import React from 'react';
import autobind from 'autobind-decorator';

import { PureComponent } from 'core/components';
import { withLocale } from 'core/decorators';
import { Icon, Link } from 'core/components/Framework7'

import classes from './styles.module.css';

class Title extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {

    }
  }

  static get defaultProps() {
    return {
      icon: "todo",
      color: false,
      title: "",
      url: "",
      hasMore: false
    }
  }

  render() {
    const { icon, color, title, url, hasMore, link, href, view, tabLink, routeTabId, preventRouter, tabLinkActive } = this.props;

    return (
      <Link
        href={link}
        routeTabId={routeTabId}
        view={view}
        tabLink={tabLink}
        tabLinkActive={tabLinkActive}
        preventRouter={preventRouter}
        className={classes.container}
        onClick={this.props.onClick}
      >
        <h2 className={classes.header}>
          <Icon icon={icon} style={{ color: color }} /> {title}
        </h2>
        {hasMore &&
          <span className={classes.more}>
            {'بیشتر ...'}
            <Icon icon="mdi-chevron-left" />
          </span>
        }
      </Link>
    )
  }
}

export default withLocale('home')(autobind(Title))